<template>
  <div class="ioRecord">
    <div class="right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
         
          <div class="form-group others">
         
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add"
                @click="addDialog()"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <div v-show="showList" class="list-right">
          <el-table
            ref="table"
            border
            v-loading="loading"
            element-loading-text="加载中..."
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column
              show-overflow-tooltip
              label="消息"
              prop="message"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="开始时间"
              prop="start_time"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="结束时间"
              prop="end_time"
            ></el-table-column>

          
            <el-table-column
              show-overflow-tooltip
              label="排序"
              prop="sequence"
            ></el-table-column>
            <!-- <el-table-column
              show-overflow-tooltip
              label="添加时间"
              prop="updateTime"
            ></el-table-column> -->
          
            <el-table-column show-overflow-tooltip label="操作" width="250px">
              <template slot-scope="scope">
                <button
                  type="button"
                  class="edit"
                  @click="editDialog(scope.row)"
                >
                  修改
                </button>
                <button class="delete" @click="del(scope.row.id)">删除</button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
    <mini-program-message-release-add
      v-if="showAddDialog"
      v-on:closeDialog="closeDialog"
    ></mini-program-message-release-add>
    <mini-program-message-release-edit
      :detail="currentRow"
      v-if="showEditDialog"
      v-on:closeDialog="closeDialog"
    ></mini-program-message-release-edit>
    <el-image-viewer
      v-if="imgViewerVisible"
      :on-close="closeImgViewer"
      :url-list="[currentImgRow.picture]"
    >
    </el-image-viewer>
  </div>
</template>
  
  <script>
import { mapState, mapMutations } from "vuex";
import { publishMessageList, publishMessageCud } from "@/api/url";
import Page from "@/page/commons/page";
import dayjs from "dayjs";
import MiniProgramMessageReleaseAdd from "./mini-program-message-release-add.vue";
import MiniProgramMessageReleaseEdit from "./mini-program-message-release-edit.vue";
import elImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "promotional-discounts",
  components: {
    Page,
    MiniProgramMessageReleaseAdd,
    MiniProgramMessageReleaseEdit,
    elImageViewer
  },
  data() {
    return {
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      groupList: [],
      tableListData: [
        {
          message: "test",
          startTime: "test",
          endTime: "test",
        
          sequence: "1",
          updateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          
        },
      ],
      tableListDataTitle: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        merchantName: "",
      },
      value4: "",
      currentRow: {},
      showAddDialog: false,
      showEditDialog: false,
      currentImgRow: {},
      imgViewerVisible: false,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      var _this = this;
      this.loading = true;
      this.$get(publishMessageList(), {
        page: curPage,
        limit: this.search.pageSize,
      })
        .then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    searchList: function () {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    closeDialog(type) {
      this.showAddDialog = false;
      this.showEditDialog = false;
      if (type == "add") {
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      }
      if (type == "edit") {
        this.tableList(this.curIndex);
      }
    },
    addDialog() {
      this.showAddDialog = true;
    },
    editDialog(row) {
      this.showEditDialog = true;
      this.currentRow = { ...row };
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this
            .$deleteRequest(publishMessageCud() + "/" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功!",
              });
              _this.tableList(_this.curIndex);
            });
        }
      );
    },
   
    
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  mounted() {
    this.search.pageNumber = 1;
    this.tableList(1);
  },
};
</script>
  
  <style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
  width: 16px;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
}
.show-list {
  height: 500px;
}
</style>
  <style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.download_btn {
  display: inline-block;
  margin-left: 15px;
}
</style>
  